"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlAllParams = exports.toTrim = exports.skipToApp = exports.savePosterImage = exports.saveImage = exports.pageInit = exports.isIybUrl = exports.isInZa = exports.isInWechat = exports.isInApp = exports.isIOS = exports.isAndroid = exports.imageToPoster = exports.goScheme = exports.getTimestamp = exports.getParameterByName = exports.getOnlineCS = exports.getBaoTongStatus = exports.getAppAgent = exports.getAppAccountId = exports.getAccountId = exports.deepCopy = exports.copyText = exports.addParameterByName = void 0;

var load = _interopRequireWildcard(require("./load"));

var _fetch = _interopRequireDefault(require("./fetch"));

var _stores = _interopRequireDefault(require("./stores"));

var _versions = _interopRequireDefault(require("./versions"));

var _bridge = _interopRequireDefault(require("./bridge"));

var _config = _interopRequireDefault(require("./config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var UA = typeof window === 'undefined' ? '' : window.navigator.userAgent.toLowerCase();
var isIOS = /iPhone|iPad|iPod/i.test(UA);
exports.isIOS = isIOS;
var isAndroid = /Android/i.test(UA); // app内，iHealthBridge 最福利、众安同一套

exports.isAndroid = isAndroid;
var isInApp = !!~UA.indexOf('iyunbao') || typeof iHealthBridge !== 'undefined';
exports.isInApp = isInApp;
var isInZa = !!~UA.indexOf('iyunbao') || typeof iHealthBridge !== 'undefined'; // 微信

exports.isInZa = isInZa;
var isInWechat = !!~UA.indexOf('micromessenger');
/**
 * 判断域名在云保域名白名单内
 * @param {string} url 链接地址
 * @return {boolean}
 */

exports.isInWechat = isInWechat;

var isIybUrl = function isIybUrl(url) {
  var result = false;
  var regWhitelistUrl = /(iyunbao.com|baoinsurance.com|iyb.tm|firstbx.com|baoyun.tech|tiyanbao.vip|zhongan.io|zhongan.com|baoyun18.com)/;

  if (typeof url === 'string') {
    var domain = url.split('?')[0];
    result = regWhitelistUrl.test(domain);
  }

  return result;
};
/**
 * 获取url参数值
 * @param {string} name 参数名字
 * @param {string} url  链接地址，可不传取当前链接地址
 * @return
 */


exports.isIybUrl = isIybUrl;

var getParameterByName = function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }

  name = name.replace(/[[]]/g, '\\$&');
  var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"));
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
/**
 * url添加参数数据
 * @param {string} name 参数名字
 * @param {string} key  参数值
 * @param {string} url  链接地址，可不传取当前链接地址
 * @return
 */


exports.getParameterByName = getParameterByName;

var addParameterByName = function addParameterByName(name, key, url) {
  if (!url) {
    url = window.location.href;
  }

  var regex = new RegExp("\\b(".concat(name, "=).*?(&|#|$)")); // 参数存在，替换value

  if (url.search(regex) >= 0) {
    return url.replace(regex, "$1".concat(key, "$2"));
  }

  var array = url.split('#');
  array[0] = "".concat(array[0], "&").concat(name, "=").concat(key).replace(/[&?]{1,2}/, '?');
  var result = array.join('#');
  return result;
};
/**
 * 获取URL全部参数
 * @param  {string} url  链接地址
 * @return {object}      返回参数值
 */


exports.addParameterByName = addParameterByName;

var urlAllParams = function urlAllParams(url) {
  if (!url) {
    url = window.location.href;
  } // Regex for replacing addition symbol with a space


  var pl = /\+/g;
  var urlParams = {};

  var decode = function decode(s) {
    return decodeURIComponent(s.replace(pl, ' '));
  };

  url = url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    urlParams[decode(key)] = decode(value);
  });
  return urlParams;
};
/**
 * 页面初始化
 * @param {function}  func  回调
 */


exports.urlAllParams = urlAllParams;

var pageInit = function pageInit(func) {
  // 添加调试工具，需要url添加参数_mobile_debug_console_
  if (getParameterByName('_mobile_debug_console_')) {
    load.js('//cdn.jsdelivr.net/npm/eruda', function () {
      eruda.init(); // eslint-disable-line
    });
  }

  func && func();
};
/**
 * 深复制
 * @param {array|object} data 数据
 */


exports.pageInit = pageInit;

var deepCopy = function deepCopy(data) {
  if (Array.isArray(data)) {
    return data.slice().map(function (item) {
      return deepCopy(item);
    });
  }

  if (Object.prototype.toString.call(data) === '[object Object]') {
    var keys = Object.keys(data);
    var dataProto = Object.getPrototypeOf(data);
    var out = dataProto === Object.prototype ? {} : Object.create(dataProto);
    keys.reduce(function (cur, key) {
      cur[key] = deepCopy(data[key]);
      return cur;
    }, out);
    return out;
  }

  return data;
};
/**
 * 获取App用户ID
 */


exports.deepCopy = deepCopy;

var getAppAccountId = function getAppAccountId() {
  return new Promise(function (resolve, reject) {
    var currentUrl = window.location.href; // App内，版本大于等于v5.3.0

    if (isInApp && _bridge.default.app_version() && _versions.default.gte(_bridge.default.app_version(), '5.3.0') && _bridge.default.accountId()) {
      return resolve(_bridge.default.accountId());
    } // 2019.10.30 分享之前链接，链接全部新增?cuid=ssd-dds--sss
    // ?wareId=100001&accountId=50004130001?cuid=dssd-2112


    if (/cuid=.*/.test(currentUrl)) {
      currentUrl = currentUrl.replace(/\?cuid=.*$/, '');
    } // 获取URL参数


    var accountId = getParameterByName('accountId', currentUrl);

    if (accountId) {
      return resolve(accountId);
    }

    var store = new _stores.default('accountId', '6m', {
      type: 'sessionStorage'
    });

    if (store.get()) {
      accountId = store.get();
      return resolve(accountId);
    }

    _fetch.default.fetch({
      path: '/agent/auth/v1/agent/info',
      server: 'api',
      method: 'GET'
    }).then(function (_ref) {
      var code = _ref.code,
          result = _ref.result,
          message = _ref.message;

      if (+code === 0) {
        store.set(result.accountId);
        resolve(result.accountId);
      } else {
        console.error('获取accountId失败');
        reject(message);
      }
    }).catch(function () {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('获取用户数据服务异常');
    });
  });
};
/**
 * 获取用户ID (已经废除，禁止使用。获取App用户tools.getAppAccountId)
 */


exports.getAppAccountId = getAppAccountId;
var getAccountId = getAppAccountId;
/**
 * 获取代理人信息
 * @param {boolean} isOpenId  获取iOpenId，防止链接参数&accountId 没有&iOpenId
 */

exports.getAccountId = getAccountId;

var getAppAgent = function getAppAgent() {
  var isOpenId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return new Promise(function (resolve, reject) {
    var currentUrl = window.location.href; // 2019.10.30 分享之前链接，链接全部新增?cuid=ssd-dds--sss
    // ?wareId=100001&accountId=50004130001?cuid=dssd-2112

    if (/cuid=.*/.test(currentUrl)) {
      currentUrl = currentUrl.replace(/\?cuid=.*$/, '');
    } // 获取URL参数


    var accountId = getParameterByName('accountId', currentUrl);
    var aSign = getParameterByName('aSign', currentUrl);
    var openId = getParameterByName('iOpenId', currentUrl);
    var values = {};

    if (accountId && aSign && openId) {
      values = {
        accountId: accountId,
        aSign: aSign,
        openId: openId
      };
      return resolve(values);
    }

    if (isOpenId) {
      if (openId) {
        return resolve({
          openId: openId
        });
      }
    } else if (accountId && aSign) {
      return resolve({
        accountId: accountId,
        aSign: aSign
      });
    }

    var store = new _stores.default('appAgent', '6m', {
      type: 'sessionStorage'
    });

    if (store.get()) {
      return resolve(store.get());
    }

    _fetch.default.fetch({
      path: '/agent/auth/v1/agent/info',
      server: 'api',
      method: 'GET'
    }).then(function (_ref2) {
      var code = _ref2.code,
          result = _ref2.result,
          message = _ref2.message;

      if (+code === 0) {
        values = {
          accountId: result.accountId,
          aSign: result.aSign,
          openId: result.openId
        };
        store.set(values);
        resolve(values);
      } else if (accountId) {
        resolve({
          accountId: accountId
        });
      } else {
        console.error('获取agent失败');
        reject(message);
      }
    }).catch(function () {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('获取用户数据服务异常');
    });
  });
};
/**
 * 判断是否是保通用户
 * @param {boolean} isOpenId  获取iOpenId，防止链接参数&accountId 没有&iOpenId
 */


exports.getAppAgent = getAppAgent;

var getBaoTongStatus = function getBaoTongStatus(accountId) {
  return new Promise(function (resolve, reject) {
    function reqBaotong(account) {
      _fetch.default.fetch({
        path: '/usercenter/auth/v1/iyb/account/baotong/entryValid',
        server: 'api',
        method: 'GET',
        data: {
          outerAccountId: account
        }
      }).then(function (_ref3) {
        var code = _ref3.code,
            result = _ref3.result,
            message = _ref3.message;

        if (+code === 0) {
          resolve(result);
        } else {
          reject(message);
        }
      }).catch(function () {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('获取保通用户数据服务异常');
      });
    }

    if (!accountId) {
      getAppAccountId().then(function (id) {
        reqBaotong(id);
      }).catch(function (error) {
        reject(error);
      });
    } else {
      reqBaotong(accountId);
    }
  });
};
/**
 * 获取智能客服URL
 * @param  {Object}   params    需要参数
 * @config {String}   accountId 推广人id
 * @config {String}   TypeCode  客服类型 product/理赔/商城/banner/搜索栏: product, claim, mall，banner, search
 * @config {String}   productId 可传，当typeCode为product时需要传入，默认会取当前参数[productId | product_id | id | wareId]，链接未有参数可以自己获取
 * @param {Function} callback  获取URL成功回调
 */


exports.getBaoTongStatus = getBaoTongStatus;

var getOnlineCS = function getOnlineCS(params, callback) {
  // 产品ID
  var productId = getParameterByName('productId') || getParameterByName('product_id') || getParameterByName('id') || getParameterByName('wareId'); // 类型，typeCode=product为产品，productId不存在获取参数值

  if (!params.productId && params.typeCode && params.typeCode === 'product') {
    params.productId = productId;
  } // 来源URL


  if (document.referrer) {
    params.fromPage = document.referrer;
  }

  getAppAccountId().then(function (accountId) {
    params.accountId = accountId;

    _fetch.default.fetch({
      path: '/open/v1/getUrl/getComposeUrl',
      server: 'club',
      method: 'GET',
      data: params
    }).then(function (_ref4) {
      var code = _ref4.code,
          result = _ref4.result;

      // 需要显示智能客服
      if (+code === 0 && result) {
        callback && callback(result);
        return false;
      }
    });
  });
};
/**
 * 去前后空格
 * @param {string} value  值
 * return {any}
 */


exports.getOnlineCS = getOnlineCS;

var toTrim = function toTrim(value) {
  if (typeof value !== 'string') {
    return value;
  }

  if (!String.prototype.trim) {
    return value.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  }

  return value.trim();
};
/**
 * 获取时间戳, 兼容safari '2019-11-5 00:00:00'
 * @param { string } date
 */


exports.toTrim = toTrim;

var getTimestamp = function getTimestamp(date) {
  if (!date) return new Date().getTime();

  if (date.indexOf('-') > 0) {
    date = date.replace(/-/g, '/');
  }

  return new Date(date).getTime();
};
/**
 * 图片生成海报。图片在同域上，允许跨域
 * @param  {string}  imgUrl      图片地址
 * @param  {object}  options     配置
 * @config {string}  width       海报图片宽度，默认获取图片尺寸
 * @config {string}  height      海报图片高度，默认获取图片尺寸
 * @config {string}  url         二维码链接
 * @config {string}  codeWidth   二维码宽度，默认100
 * @config {string}  codeHeight  二维码高度，默认100
 * @config {string}  codeX       二维码 x 坐标
 * @config {string}  codeY       二维码 y 坐标
 * @param {function}  callback   回调
 */


exports.getTimestamp = getTimestamp;

var imageToPoster = function imageToPoster(imgUrl) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = arguments.length > 2 ? arguments[2] : undefined;
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  options = _extends({
    codeX: 0,
    codeY: 0,
    codeWidth: 100,
    codeHeight: 100
  }, options);
  var _options = options,
      url = _options.url,
      codeX = _options.codeX,
      codeY = _options.codeY;
  var image = new Image();
  image.crossOrigin = 'anonymous';
  image.src = imgUrl;

  image.onload = function () {
    options.width = options.width || image.width;
    options.height = options.height || image.height;
    canvas.width = options.width;
    canvas.height = options.height;
    ctx.drawImage(image, 0, 0, options.width, options.height); // 生成二维码

    if (url) {
      var qrcodeUrl = "".concat(_config.default.URL.api, "/facilities/open/v1/qrcode/getImg?content=").concat(encodeURIComponent(url));
      var qrcodeImage = new Image();
      qrcodeImage.crossOrigin = 'anonymous';
      qrcodeImage.src = qrcodeUrl;

      qrcodeImage.onload = function () {
        options.codeWidth = options.codeWidth || qrcodeImage.width;
        options.codeHeight = options.codeHeight || qrcodeImage.height;
        ctx.drawImage(qrcodeImage, codeX, codeY, options.codeWidth, options.codeHeight);
        var base64 = canvas.toDataURL('image/png');
        callback && callback(base64);
      };
    } else {
      var base64 = canvas.toDataURL('image/png');
      callback && callback(base64);
    }
  };
};
/**
 * 保存图片
 * @param {string}    url        图片地址、base64
 * @param {function}  callback   回调
 */


exports.imageToPoster = imageToPoster;

var saveImage = function saveImage(url, callback) {
  var pageUrl = '//static.iyb.tm/web/lib/utils/html/saveImage.html';

  var updateImage = function updateImage() {
    if (/^data:image\/.*;base64/.test(url)) {
      var formData = new FormData();
      formData.append('suffix', 'jpg');
      formData.append('fileName', 'saveImage');
      formData.append('base64Val', url);
      fetch("".concat(_config.default.URL.api, "/facilities/open/v1/oss/file/upload/byBase64"), {
        method: 'post',
        body: formData
      }).then(function (res) {
        return res.text();
      }).then(function (result) {
        var data = JSON.parse(result);

        if (data.isSuccess && data.result && data.result.url) {
          window.location.href = "".concat(pageUrl, "?url=").concat(encodeURIComponent(data.result.url));
          callback && callback();
        }
      });
    } else {
      window.location.href = "".concat(pageUrl, "?url=").concat(encodeURIComponent(url));
      callback && callback();
    }
  };

  if (isInApp) {
    _bridge.default.ready(function () {
      if (isAndroid && _versions.default.lt(_bridge.default.app_version(), '5.3.0')) {
        // 跳转页面 长按图片保存
        updateImage();
      } else {
        _bridge.default.saveImage({
          imgUrl: url
        });

        callback && callback();
      }
    });
  } else {
    // 跳转页面 长按图片保存
    updateImage();
  }
};
/**
 * 生成海报／保存图片
 * @param  {string}  imgUrl      图片地址
 * @param  {object}  options     配置
 * @config {string}  width       海报图片宽度，默认获取图片尺寸
 * @config {string}  height      海报图片高度，默认获取图片尺寸
 * @config {string}  url         二维码链接
 * @config {string}  codeWidth   二维码宽度，默认100
 * @config {string}  codeHeight  二维码高度，默认100
 * @config {string}  codeX       二维码 x 坐标
 * @config {string}  codeY       二维码 y 坐标
 * @param {function}  callback   回调
 */


exports.saveImage = saveImage;

var savePosterImage = function savePosterImage(imgUrl) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = arguments.length > 2 ? arguments[2] : undefined;
  imageToPoster(imgUrl, options, function (url) {
    saveImage(url, callback);
  });
};
/**
 * 特殊toast，只用于限制内部
 * @param {string}   content   内容
 * @param {number}   duration  自动关闭的延时，单位毫秒
 * @param {function} onClose   关闭时触发的回调函数
 */


exports.savePosterImage = savePosterImage;

var Toast = function Toast(content, duration, onClose) {
  if (typeof __iybComponents === 'undefined') {
    load.css('//static.iyb.tm/web/lib/components/iyb-components.min.css');
    load.js('//static.iyb.tm/web/lib/components/iyb-components.min.js', function () {
      // eslint-disable-next-line no-undef
      __iybComponents.Toast.warning(content, duration, onClose);
    });
  } else {
    // eslint-disable-next-line no-undef
    __iybComponents.Toast.warning(content, duration, onClose);
  }
};
/**
 * 复制文字
 * @param {string} text  文字
 * return {boolean}
 */


var copyText = function copyText(text) {
  if (typeof text !== 'string') {
    console.error('请传入字符串');
    return false;
  }

  try {
    var div = document.createElement('div');
    div.innerHTML = text;
    document.body.appendChild(div);
    window.getSelection().removeAllRanges();
    var range = document.createRange();
    range.selectNode(div);
    window.getSelection().addRange(range);
    var success = document.execCommand('copy');

    if (success) {
      Toast('复制成功');
    } else {
      Toast('复制失败');
    }

    window.getSelection().removeAllRanges();
    document.body.removeChild(div);
    return true;
  } catch (error) {
    console.error(error);
  }

  return false;
};
/**
 * 跳转到app
 * @param { string } scheme 跳转的app页面地址
 */


exports.copyText = copyText;

var skipToApp = function skipToApp(scheme) {
  var _scheme = scheme;

  if (!scheme) {
    _scheme = getParameterByName('_scheme');
  }

  if (!_scheme) {
    console.error('scheme is not defined');
    return;
  }

  if (!/iyunbao:\/\/.*/.test(_scheme) && !/^(https{0,1}:\/\/).+/.test(_scheme)) {
    _scheme = "iyunbao://".concat(_scheme);
  }

  if (isInApp) {
    _bridge.default.go(_scheme);

    return;
  }

  window.location.href = "https://h5.iyunbao.com/m/home/callApp?url=".concat(encodeURIComponent(_scheme));
};
/**
 *
 * @param {*} scheme 跳转到的原生地址
 */


exports.skipToApp = skipToApp;

var goScheme = function goScheme() {
  var scheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  // scheme 兼容的最低版本信息
  try {
    var schemeConfig = {
      'iyunbao://shipAddress': '6.0.0'
    }; // 如果不在app内 则跳转下载app的地址

    var issChemeUrl = /iyunbao:\/\/.*/.test(scheme); // 非scheme地址

    if (!issChemeUrl) {
      _bridge.default.go(scheme); // 在app外部

    } else if (_bridge.default.isInApp) {
      skipToApp(scheme);
    } else {
      // scheme 兼容的最低版本
      var schemeVersion = schemeConfig[scheme] || '0.0.0'; // 当前的版本信息

      var cureentVersion = _bridge.default.app_version(); // 当前版本大于等于scheme的最小地址则跳转到 非则进行提示


      if (_versions.default.gte(cureentVersion, schemeVersion)) {
        _bridge.default.go(scheme);
      } else {
        Toast('请升级app至最新版本');
      }
    }
  } catch (error) {
    console.error('goScheme:', error);
  }
};

exports.goScheme = goScheme;